import * as React from 'react'
import { Input } from '@metrisk/react_metrisk-components'

import { locale } from '@app/utils/intl'
import parseCurrency from './parseCurrency'

// Styles
import './Currency.scss'

const CurrencyInput: React.FunctionComponent<Currency.IProps> = (props) => {
  const { name, value, currency, onChange } = props

  const handleChange = (value: string) => {
    const [lowestUnitAmount, displayAmount]: any = parseCurrency(value, currency, locale)
    onChange({ input: value, amount: lowestUnitAmount, currency, displayAmount })
  }

  return <Input name={name} value={value?.input || ''} onChange={handleChange} autoComplete="off" />
}

export default CurrencyInput
